// :cow: Cosmose CONFIDENTIAL :iso:
import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatService } from '@coa/app/shared/chart-data-series/services/date-format.service';
import { DataSeries } from '@coa/app/shared/spy-line-chart/model/data-series';
import { ChartExtendedDataType } from '@coa/app/home/modules/floor-details/components/floor-details-body/floor-details-content/chart-extended-data.type';
import { OfflineTrafficSeries } from '@coa/app/shared/stores-shared/models/offline-traffic-series';
import { Series } from '@coa/app/shared/stores-shared/models/series';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dataSeries',
})
export class DataSeriesPipe implements PipeTransform {

  constructor(
    private dateFormatService: DateFormatService,
    private translate: TranslateService,
  ) {
  }

  transform(series: any, chartExtendedData: ChartExtendedDataType): DataSeries {
    if (!series) {
      return null;
    }

    if (!chartExtendedData) {
      return undefined;
    }

    return {
      chartSeries: this.getSeries(series, chartExtendedData).map(element => ({
        value: element.value,
        label: this.dateFormatService.formatLabel(element.key),
      })),
      label: this.translate.instant(chartExtendedData),
    };
  }

  private getSeries(series: OfflineTrafficSeries, chartExtendedData: ChartExtendedDataType): Series[] {
    switch (chartExtendedData) {
      case ChartExtendedDataType.PAYMENTS:
        return series.paymentStats;
      case ChartExtendedDataType.UNIQUE_VISITS:
        return series.uniqueVisitsStats;
      case ChartExtendedDataType.PAYING:
        return series.paymentStats;
      case ChartExtendedDataType.NONPAYING:
        return series.nonPayingCustomers;
      default:
        return series.offlineTraffic;
    }
  }
}
